import React from 'react';
import {MoreInfoStatic} from 'shared/components/MoreInfo/MoreInfo';

export const MinimumChargeMoreInfo = () => {
    return (
        <MoreInfoStatic
            editbuttonVisible={false}
            hoverText="Minimum charge"
            dialogClassName="modal-md"
            info="Your order is below the minimum value threshold, so a fee has been applied. Adding more items can reduce or remove this fee."
        />
    );
};
